module.exports = __webpack_public_path__ + "img/simetrograph.9e4b52af.png";